// extracted by mini-css-extract-plugin
module.exports = {"container":"PC-module__container___ga-Px"};